import {BaseConstants, PaletteOptions, Render} from "oca-lib-web";
import Constants from "./util/Constants";
import RouteManager from "./auth/components/RouteManager";
import './style/style.css';
import DashboardPage from "./container/DashboardPage";
import Amplify from 'aws-amplify';
import aws_exports_dev from './aws-exports-dev';
import aws_exports_prod from './aws-exports-prod';
import ProjectPage from "./container/ProjectPage";
import ReactGA from 'react-ga';
import {Palette} from "oca-lib-web";
import SendNotificationPage from "./container/SendNotificationPage";
import MessagingPage from "./container/MessagingPage";
import AdminPage from "./container/AdminPage";
import DataAccess from "./data/DataAccess";
import { setGlobal, getGlobal } from 'reactn';
import AppStoreConnectDataAccess from "./data/AppStoreConnectDataAccess";
import GooglePlayDataAccess from "./data/GooglePlayDataAccess";
import FlurryDataAccess from "./data/FlurryDataAccess";
import GoogleAnalyticsDataAccess from "./data/GoogleAnalyticsDataAccess";
import CustomDataAccess from "./data/CustomDataAccess";
import AppReviewDataAccess from "./data/AppReviewDataAccess";
import TwitterDataAccess from "./data/TwitterDataAccess";
import DataManager from "./util/DataManager";
//import { LinkedInPopUp } from 'react-linkedin-login-oauth2';
import LinkedInPage from "./container/LinkedInPage";
import ProfilePage from "./container/ProfilePage";
import analyticsLogo from "./image/analytics_logo_large.png";

Amplify.configure(aws_exports_dev);
let STAGE = process.env.REACT_APP_STAGE;
if (STAGE == BaseConstants.DEV) {
    Amplify.configure(aws_exports_dev);
} else if (STAGE == BaseConstants.PROD) {
    Amplify.configure(aws_exports_prod);
}

/*const { route } = useAuthenticator(context => [context.route]);
if (route === "authenticated"){
    console.log("authenticated")
}*/

RouteManager.addRouteWithComponent("/", DashboardPage);
RouteManager.addRouteWithComponent("/linkedin", LinkedInPage);
//RouteManager.addRouteWithComponent("/", AppStorePage);
RouteManager.addAuthenticatedRouteWithComponent("/dashboard", DashboardPage);
RouteManager.addAuthenticatedRouteWithComponent("/admin", AdminPage);
RouteManager.addAuthenticatedRouteWithComponent("/project", ProjectPage);
RouteManager.addAuthenticatedRouteWithComponent("/project/:id", ProjectPage);
RouteManager.addAuthenticatedRouteWithComponent("/messaging", MessagingPage);
RouteManager.addAuthenticatedRouteWithComponent("/profile", ProfilePage);
RouteManager.addAuthenticatedRouteWithComponent("/sendNotification/:projectId", SendNotificationPage);

ReactGA.initialize('UA-132680044-3');
ReactGA.pageview(window.location.pathname + window.location.search);

setGlobal({dataManager: new DataManager(new DataAccess()), appstore:new AppStoreConnectDataAccess(), appreviews:new AppReviewDataAccess(), googleplay:new GooglePlayDataAccess(),
    flurry:new FlurryDataAccess(), googleanalytics:new GoogleAnalyticsDataAccess(), twitter:new TwitterDataAccess(), customdata:new CustomDataAccess()});

var handleAuthStateChangeCallback = async (arg1: string) => {
    console.log("Setting global state");
    let dataManager = getGlobal().dataManager;
    let user = await dataManager.get("getCurrentUser");
    console.log(user);

    setGlobal({user:user, isGlobalLoaded:true});
};

let settings:AuthSettings = {
    title: 'Apptimize Analytics',
    image: analyticsLogo,
    signupEnabled: true,
    loginSuccessRoute: 'dashboard',
    loginMechanisms: ['email'],
    signUpAttributes: ['name', 'email', 'phone_number'],
    handleAuthStateChangeCallback: handleAuthStateChangeCallback
};

let pallette:PaletteOptions = {
    primary: Constants.BLUE_COLOR,
    secondary: Constants.LIGHT_GRAY_COLOR
};

Render.renderReactDOM(Palette.create(pallette, RouteManager.renderRouter(settings)));